import {
  isUtilityItemDropoutByRenter,
  isUtilityItemNotNeededByRenter,
} from 'common/utility/helpers';
import {
  UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED,
  UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT,
  UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED,
  UTILITY_TYPE_ID_ELECTRICITY,
} from 'common/utility/constants';

const completed = Object.freeze({
  icon: 'checkmark-green-bold-active',
  tooltip: {
    text: 'Completed',
    className: 'utility-completed',
  },
});

const completedOnSwitch = Object.freeze({
  icon: 'star-verified-utility-setup',
  tooltip: {
    text: 'Verified utility confirmation',
    className: 'utility-onswitch-verified',
  },
});

const completedOutside = Object.freeze({
  icon: 'green-checkmark-ghost',
  tooltip: {
    text: 'Completed. Purchased outside of platform',
    className: 'utility-ghost',
  },
});

const notNeeded = Object.freeze({
  icon: 'green-checkmark-ghost',
  tooltip: {
    text: 'Not needed. Part of rent',
    className: 'utility-ghost',
  },
});

const incompleted = Object.freeze({
  icon: 'clock-icon-orange',
  tooltip: {
    text: 'Incomplete',
    className: 'utility-incompleted',
  },
});

const finalizing = Object.freeze({
  icon: 'checkmark-orange-small-active',
  tooltip: {
    text: 'Finalizing Purchase',
    className: 'utility-purchase-requested',
  },
});

/**
 * Icon and tooltip for one utility in a partner's activations table.
 *
 * A utility the renter does not need (part of rent) is checked first, for every type: the
 * renter page leaves it out of progress, so showing it as incomplete here would give the
 * partner a different answer than the renter sees. Electricity otherwise only counts a
 * dropout as done when the renter recorded the account they set up outside the platform.
 */
export const getActivationItemRowState = ({ activationItem }) => {
  const resolveCompleted = activationItem.verifiedOrder ? completedOnSwitch : completed;

  if (isUtilityItemNotNeededByRenter(activationItem)) {
    return notNeeded;
  }

  if (activationItem.type.id === UTILITY_TYPE_ID_ELECTRICITY) {
    if (activationItem.status === UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED) {
      return resolveCompleted;
    }

    const dropoutByRenter = isUtilityItemDropoutByRenter(activationItem);
    const hasAccountDetails = activationItem.accountNumber || activationItem.activationDate;

    if (dropoutByRenter && hasAccountDetails) {
      return resolveCompleted;
    }

    return incompleted;
  }

  if (activationItem.status === UTILITY_ACTIVATION_ITEM_STATUS_COMPLETED) {
    return resolveCompleted;
  }
  if (activationItem.status === UTILITY_ACTIVATION_ITEM_STATUS_ACCOUNT_REQUESTED) {
    return finalizing;
  }
  if (activationItem.status === UTILITY_ACTIVATION_ITEM_STATUS_DROPOUT) {
    return completedOutside;
  }
  return incompleted;
};
